import { render } from "./TaskBoard.vue?vue&type=template&id=5d027a36&scoped=true"
import script from "./TaskBoard.vue?vue&type=script&lang=js"
export * from "./TaskBoard.vue?vue&type=script&lang=js"

import "./TaskBoard.vue?vue&type=style&index=0&id=5d027a36&lang=scss&scoped=true"
import "./TaskBoard.vue?vue&type=style&index=1&id=5d027a36&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d027a36"],['__file',"src/views/h5/crm/project/manage/TaskBoard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d027a36"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d027a36', __exports__)) {
    api.reload('5d027a36', __exports__)
  }
  
  module.hot.accept("./TaskBoard.vue?vue&type=template&id=5d027a36&scoped=true", () => {
    api.rerender('5d027a36', render)
  })

}


export default __exports__